module.exports = __webpack_public_path__ + "img/1.e1ac265e.png";